<div class="flex justify--center">
  <ta-link
    *ngFor="let tab of tabs"
    [taRouterLink]="!tabIsActive(tab) ? tab.path : null "
    [disabled]="tab.disabled"
  >
    <div
      class="p--2 mh--1 f--6 tt--uppercase"
      [ngClass]="{
				'color--default': !tab.disabled && (activeTab == null || !tabIsActive(tab)),
				'color--heading-dark bold border--dark border--bottom': tabIsActive(tab),
				'color--default-lighter': tab.disabled
			}"
    >
      {{ tab.label }}
      <ta-icon *ngIf="tab.icon != null" [icon]="tab.icon"></ta-icon>
    </div>
  </ta-link>
</div>
